import 'rev-shared/bootstrap/SharedImports';

import { bootstrapAngularApp } from 'rev-shared/bootstrap/AngularAppBootstrapUtils';
import { EmbedModule } from './Embed.Module';

bootstrapAngularApp(EmbedModule);
